import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '@/layouts/Root';
import ApperIcon from '@/components/ApperIcon';

const AccessDeniedPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const message = searchParams.get('message') || "Non hai i permessi per accedere a questa pagina.";

  const handleLogout = async () => {
    await logout();
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-primary p-4">
      <div className="w-full max-w-md text-center">
        <div className="w-20 h-20 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <ApperIcon name="ShieldX" size={40} className="text-red-400" />
        </div>
        <h1 className="text-3xl font-bold text-white mb-3">Accesso Negato</h1>
        <p className="text-gray-400 mb-8">{message}</p>
        <div className="space-y-3">
          <button
            type="button"
            onClick={handleGoBack}
            className="w-full px-6 py-3 bg-primary text-white rounded-button hover:bg-primary-600 transition-colors font-medium flex items-center justify-center gap-2"
          >
            <ApperIcon name="ArrowLeft" size={18} />
            Torna Indietro
          </button>
          <button
            type="button"
            onClick={handleLogout}
            className="w-full px-6 py-3 bg-surface text-gray-300 rounded-button hover:bg-primary/10 transition-colors font-medium flex items-center justify-center gap-2"
          >
            <ApperIcon name="LogOut" size={18} />
            Esci
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccessDeniedPage;